import React, {useEffect} from "react";
import { Footer, Header } from "../Components";
import FooterTopBar from "../Components/FooterTopBar";

export const PaymentTerms = () => {
  document.title = "Terms and Conditions for Online Payments - Famra Cure";
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-left mb-8 text-sky-800">
            Terms and Conditions for Online Payments
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">Introduction</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Famraz LLC, on behalf of itself under the brand "Famra Cure", is the author and publisher of the internet resource <a href="http://www.famracure.com" className="text-sky-800 hover:text-sky-600 underline transition-colors" target="_blank" rel="noopener noreferrer">www.famracure.com</a>. Famraz LLC owns and operates the services provided through the Website. These terms and conditions apply to the customer who utilizes any of the services offered by Famraz LLC through any of its platforms (Web/App) by making a payment to Famracure.com.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Kindly read these terms and conditions carefully. By authorizing a payment to Famraz LLC through the online payment service ("the service"), it would be treated as a deemed acceptance of these terms and conditions. Famraz LLC reserves all the rights to amend these terms and conditions at any time without giving prior notice. It is the responsibility of the Customer to have read the terms and conditions before using the Service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">Key Terms & Conditions</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-4">
                <li>
                  <strong>Accepted Payment Methods:</strong> Payments can be made via Credit/Debit cards only.
                </li>
                <li>
                  <strong>Transaction Fees:</strong> Customers are advised to check with their bank or card provider regarding any additional transaction fees or charges.
                </li>
                <li>
                  <strong>Information Accuracy:</strong> Famraz LLC does not store your card details; they are processed securely by our payment gateway. It is your responsibility to ensure all entered information is accurate. We recommend keeping a copy of your transaction receipt for your records.
                </li>
                <li>
                  <strong>Security & Risk:</strong> While we use secure gateways, data transmitted over the internet is inherently at risk of hacking or fraud. Famraz LLC and its Payment Providers are not liable for unauthorized third-party interceptions or data misuse beyond our control.
                </li>
                <li>
                  <strong>Liability Limitation:</strong> Famraz LLC, its directors, and employees are not liable for any direct or indirect damages, data errors, or service interruptions. We are not responsible for failures caused by circumstances beyond our reasonable control.
                </li>
                <li>
                  <strong>Authorized Use:</strong> By initiating a payment, you confirm that you are the lawful owner (or an authorized user) of the payment instrument and that sufficient funds are available to cover the total fees.
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4 text-sky-700">Contact Us</h2>
              <p className="text-gray-700 leading-relaxed">
                For billing inquiries or payment issues, please contact our billing department at <a href="mailto:billing@famracure.com" className="font-bold text-sky-800 hover:text-sky-600 transition-colors">billing@famracure.com</a>
              </p>
            </section>

            <p className="text-sm text-gray-600 mt-8 pt-4 border-t">
              Last Updated: June 2026
            </p>
          </div>
        </div>
      </div>
      <FooterTopBar />
      <Footer />
    </>
  );
};

export default PaymentTerms;
